import Vue from 'vue'
import Vuex from 'vuex'
//import {_} from 'vue-underscore'
import axios from 'axios'

Vue.use(Vuex)
Vue.config.devtools = true

export const store = new Vuex.Store({
  state: {
    app_data: {
      ready: false,
      busy: false,
      error: false,
      loading: false
    },
    options: false,
    params: {
      filters: {
        text: ''
      },
      paging: {
        page: 1,
        items_per_page: 25
      },
      sorting: {
        field: 0,
        dir: 'asc'
      }
    },
    result: false
  },
  mutations: {
    app (state, data) {
      state.app_data[data.key] = data.value
    },
    error (state, error) {
      state.app_data.error = error
    },
    filter (state, data) {
      state.params.filters[data.key] = data.value
    },
    page (state, page) {
      state.params.paging.page = page
    },
    result (state, result) {
      state.result = result
    },
    setup (state, config) {
      state.options = config
      state.params.sorting = config.default_sort
      if (config.items_per_page) {
        state.params.paging.items_per_page = config.items_per_page
      }
      state.app_data.ready = true
    },
    sort (state, field_id) {
      if (field_id == state.params.sorting.field) {
        this.state.params.sorting.dir = (this.state.params.sorting.dir == 'asc' ? 'desc' : 'asc')
      } else {
        this.state.params.sorting = {
          field: field_id,
          dir: 'asc'
        }
      }
    },
  },
  getters: {
    busy: state => state.app_data.busy,
    columns: state => state.options.columns,
    error: state => state.app_data.error,
    options: state => state.options,
    params: state => state.params,
    ready: state => state.app_data.ready,
    result: state => state.result

  },
  actions: {
    getData ({ commit, getters }, reset) {
      if (!getters.busy) {
        if (reset) {
          commit('page', 1)
        }
        commit('app', { key: 'busy', value: true })
        axios.post(getters.options.url, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          },
          params: getters.params,
          responseType: 'json'
        }).then(function (response) {
          if (response.data.success) {
            commit('result', response.data.result)
          } else {
            console.log(response.data)
          }
          commit('app', { key: 'busy', value: false })
        }).catch(function () {
          commit(
            'error', 
            'An error occurred. Unable to retrieve data.'
          )
          commit('app', { key: 'busy', value: false })
        })
      }
    }
  }
})